import React, { useEffect, useState } from "react";
import Deposit from "../Components/walletModel/Deposit";
import Withrow from "../Components/walletModel/Withrow";
import RewardsIcon from "../assets/rewards-icon.png"
import ArrowLeft from "../assets/left-icon.png"
import { Link, useNavigate } from 'react-router-dom'
import { BookingHoteDetailAndImagesAPI, GetProfileDetailAPI, GetTransactionHistory, GetUserWalletAPI } from "../Service/API/Get";

export default function Wallet() {
    const navigate = useNavigate();
    const [isDeposit, setIsDeposit] = useState(false)
    const [isWithrow, SetIsWithrow] = useState(false)
    const [hotelDetails, setHotelDetails] = useState([]);
    const [userProfileData, setUserProfileData] = useState({});
    const [userWalletData, setUserWalletData] = useState({})
    const [transactionData, setTransactionData] = useState([]);
    const [selectedOption, setSelectedOption] = useState('Select')

    useEffect(() => {
        const fetchData = async () => {
            try {
                const hotelResponse = await BookingHoteDetailAndImagesAPI();
                if (hotelResponse?.data) {
                    setHotelDetails(hotelResponse.data.result.data);
                }
                const profileResponse = await GetProfileDetailAPI();
                if (profileResponse?.data) {
                    setUserProfileData(profileResponse.data.result.data);
                }
                const userWalletResponse = await GetUserWalletAPI();
                if (userWalletResponse?.data) {
                    setUserWalletData(userWalletResponse.data.result.data)
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setHotelDetails([]);
                setUserProfileData({});
            }
        };
        fetchData();
    }, []);

    const handleSelectChange = async (event) => {
        const value = event.target.value.toLowerCase();
        setSelectedOption(value)
        if (value !== "Select") {
            try {
                const response = await GetTransactionHistory(value);
                if (response?.data) {
                    setTransactionData(response?.data?.result?.data)
                } else {
                    setTransactionData([])
                }
            } catch (error) {
                console.error("Error fetching transaction history:", error);
            }
        }
    };

    function formatAmount(amount) {
        if (amount % 1 >= 0.5) {
            return Math.ceil(amount);
        } else {
            return Math.floor(amount);
        }
    }

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear().toString().slice(0, 4);
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        hours = hours % 12;
        hours = hours ? String(hours).padStart(2, '0') : '12';
        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    };

    const formattedTodayCommission = formatAmount(userWalletData.todayCommission);

    const capitalizeFirstLetter = (str) => {
        if (str) {
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        }
        return '';
    };

    return (
        <>
            <div className='rewards_section'>
                <div className='container'>
                    <div className='rewards_heading'>
                        <img src={RewardsIcon} />
                        <p>Book Now & Earn Rewards</p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className='inner_title_section'>
                    <div className='container'>
                        <div className='inner_title_flex'>
                            <Link to='/booking'> <img src={ArrowLeft} /></Link>
                            <h3>Wallet</h3>
                        </div>
                    </div>
                </div>
                <div className="wallet_box wallet_sec">
                    <div className="wallet_box_top">
                        <h5>Task Count: {userProfileData?.taskCount || 0}</h5>
                    </div>
                    <div className="wallet_box_top">
                        <h4>The reservation information is displayed in detail for your viewing</h4>
                    </div>

                    <div className="wallet_box_middle">
                        <div className="wallet_box_middle_left">
                            <label>Trial Bonus</label>
                            <h5>₹ {userWalletData?.levelBonus || 0}</h5>
                        </div>
                        <div className="wallet_box_middle_right">
                            <label>Balance</label>
                            <h5>₹ {userWalletData?.totalBalance?.toFixed(0) || 0}</h5>
                        </div>
                    </div>
                    <div className="wallet_box_middle wallet_box_middle_last">
                        <div className="wallet_box_middle_left">
                            <label>Today commission</label>
                            <h5>₹ {formattedTodayCommission || 0}</h5>
                        </div>
                        <div className="wallet_box_middle_right">
                            <label>Pending Amount</label>
                            <h5>₹ {userWalletData?.pendingAmount || "0"}</h5>
                        </div>
                    </div>
                </div>

                <div className="wallet_btn_grp">
                    <button className="deposit_btn" onClick={() => navigate("/deposit")}>Deposit</button>
                    <button className="withdraw_btn">Withdraw</button>
                </div>

                <div className="wallet_box">
                    <div className="wallet_box_top">
                        <h4>Transaction History</h4>
                        <div className="wallet_selector">
                            <select onChange={handleSelectChange}>
                                <option value="" disabled selected>Select</option>
                                <option value="Withdraw">Withdraw</option>
                                <option value="Deposit">Deposit</option>
                            </select>
                        </div>
                    </div>
                    <div className="table_responsive_wallet">
                        {selectedOption === "Select" ? (
                            <p>-</p>
                        ) : (
                            <div className="table-responsive">
                                {transactionData && transactionData.length > 0 ? (
                                    <table className="table history_table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Type</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactionData.map((detail, index) => (
                                                <tr key={index}>
                                                    <td>{formatDate(detail?.createdAt)}</td>
                                                    <td>₹{detail?.amount}</td>
                                                    <td style={{ color: "red" }}>{capitalizeFirstLetter(detail?.type)}</td>
                                                    <td style={{ color: "green" }}>{capitalizeFirstLetter(detail?.status)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <p>There is no data</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {isDeposit && <Deposit />}
            {/* <Deposit />
                <Withrow /> */}
        </>
    )
}